import script from "./heard.vue?vue&type=script&lang=ts&setup=true"
export * from "./heard.vue?vue&type=script&lang=ts&setup=true"

import "./heard.vue?vue&type=style&index=0&id=0c2b98cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2b98cc"]])

export default __exports__